<template>
  <div class="flex justify-center text-sm">
    <span class="text-gray-500">
      By registering, you accept our

      <nuxt-link class="link" to="/terms-and-conditions">
        Terms and Conditions</nuxt-link>.
    </span>
  </div>
</template>
